import React from "react";
import { Text, useMantineTheme } from "@mantine/core";

interface BodyTextProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * BodyText - Default 16px body paragraph. Semantic body role.
 * Enforces the 70ch measure ceiling for comfortable line length.
 * For subordinate/dimmed body use <DimmedText>. For emphasized intro use <Lead>.
 * Usage: <BodyText>The default paragraph in an article or bio.</BodyText>
 */
export const BodyText: React.FC<BodyTextProps> = ({ children, className, style }) => {
  const theme = useMantineTheme();
  const other = theme.other as Record<string, string>;

  return (
    <Text
      className={className}
      style={{
        color: other.textPrimary,
        fontSize: "1rem",
        fontWeight: 400,
        lineHeight: 1.65,
        maxWidth: "70ch",
        ...style,
      }}
    >
      {children}
    </Text>
  );
};

export default BodyText;
